import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { PageHeader } from "@/components/Primitives";
import { BookingForm } from "@/components/BookingForm";

export default function BookingNew() {
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const [files, setFiles] = useState([]);

  async function submit(payload) {
    setBusy(true);
    try {
      const r = await api.post("/bookings", payload);
      const b = r.data;
      let failed = 0;
      for (const f of files) {
        const fd = new FormData();
        fd.append("file", f.file);
        fd.append("kind", f.kind);
        try { await api.post(`/bookings/${b.id}/documents`, fd); } catch { failed += 1; }
      }
      toast.success(`${b.booking_ref} submitted to Payment Desk`);
      if (failed) toast.error(`${failed} attachment(s) failed to upload — retry from the booking page`);
      nav(`/bookings/${b.id}`);
    } catch (e) {
      toast.error(apiError(e, "Could not create booking"));
    } finally { setBusy(false); }
  }

  return (
    <div data-testid="booking-new-page">
      <PageHeader eyebrow="Sales" title="New Booking" />
      <BookingForm mode="create" onSubmit={submit} submitting={busy} files={files} setFiles={setFiles} />
    </div>
  );
}
